export default __webpack_public_path__ + "static/media/Teachersday5.32895cbd.JPG";